// components/UsersDataTable.jsx
import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { useStateContext } from '../../Contexts/ContextProvider';
import { DataTable, PageHeader } from '../../componants/Workspace';

const UsersDataTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const {data } = useStateContext () ; 

  if (!data) {
    return <div className="workspace-empty">No report data was provided.</div>;
  }
  const title = 'Reports';
  const users = data;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(users.length / usersPerPage);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
    XLSX.writeFile(workbook, `${title.replace(/\s/g, "_")}.xlsx`);
  };

  return (
    <>
      <PageHeader
        title={title}
        description={`${users.length} records`}
        actions={(
          <button className="btn btn-outline-secondary" onClick={exportToExcel} type="button">
            <i className="material-icons" aria-hidden="true">download</i>
            Export to Excel
          </button>
        )}
      />
      <DataTable>
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Email</th>
            <th>Country</th>
            <th>Status</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map((user, index) => (
            <tr key={user._id || index}>
              <td>{indexOfFirstUser + index + 1}</td>
              <td>{user.fullname || user.name}</td>
              <td>{user.email}</td>
              <td>{user.country}</td>
              <td>{user.status}</td>
              <td>{user.position}</td>
            </tr>
          ))}
        </tbody>
      </DataTable>

      {totalPages > 1 && (
        <nav className="workspace-pagination" aria-label="Report pages">
          <ul className="pagination mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button className="page-link" disabled={currentPage === 1} onClick={() => setCurrentPage((prev) => prev - 1)} aria-label="Previous page">&laquo;</button>
          </li>
          {[...Array(totalPages)].map((_, idx) => (
            <li key={idx} className={`page-item ${currentPage === idx + 1 && 'active'}`}>
              <button className="page-link" onClick={() => setCurrentPage(idx + 1)} aria-current={currentPage === idx + 1 ? 'page' : undefined}>{idx + 1}</button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" disabled={currentPage === totalPages} onClick={() => setCurrentPage((prev) => prev + 1)} aria-label="Next page">&raquo;</button>
          </li>
        </ul>
      </nav>
      )}
    </>
  );
};

export default UsersDataTable;
